<template>
  <base-container class="layout-row" ref="container" :isLoading="loading">
    <artisan-group
      title="检查资源"
      border
      style="height: 100%; width: 240px; background-color: #fff"
    >
      <el-tree
        :data="resTree"
        :props="defaultProps"
        @node-click="handleNodeClick"
        default-expand-all
        current-node-key="id"
        :expand-on-click-node="false"
      >
        <span style="flex: 1" slot-scope="{ node, data }">
          <span :class="data.id == resId ? 'color-primary' : ''">
            {{ node.label }}
          </span>
        </span>
      </el-tree>
    </artisan-group>
    <div
      style="
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin: 0 5px;
        height: 100%;
      "
    >
      <artisan-calendar
        v-if="showCalendar"
        v-model="scheduleDate"
        ref="calendar"
        @monthChange="monthChange"
      >
        <template slot="dateCell" slot-scope="{ date }">
          <el-row
            style="position: relative; margin: 2px"
            :class="getDateClass(date)"
            type="flex"
            align="middle"
          >
            <div
              :class="date == scheduleDate ? 'date-current' : ''"
              class="schedule-date"
            >
              {{ date.slice(-2) }}
            </div>
            <div style="flex: 1" class="align-center color-gray">
              <div
                v-if="dayScheduleMap[date] && dayScheduleMap[date].hasSchedule"
                style="font-size: 19px"
                class="color-info"
              >
                <span class="color-success">
                  {{ dayScheduleMap[date].resCount }}
                </span>
                <span style="margin: 0 3px">/</span>
                <span>
                  {{ dayScheduleMap[date].totalCount }}
                </span>
              </div>
              <div
                v-else
                class="color-gray align-center"
                style="margin: 10px 5px"
              >
                --
              </div>
            </div>
            <el-tag
              size="mini"
              v-if="
                dayScheduleMap[date] &&
                dayScheduleMap[date].dateType == 'holiday'
              "
              style="position: absolute; right: 0; top: 0"
              type="success"
              effect="dark"
            >
              休
            </el-tag>
            <el-tag
              size="mini"
              v-else-if="
                dayScheduleMap[date] &&
                dayScheduleMap[date].dateType == 'adjust'
              "
              style="position: absolute; right: 0; top: 0"
              type="danger"
              effect="dark"
            >
              班
            </el-tag>
          </el-row>
        </template>
      </artisan-calendar>
      <div style="height: 40%" v-else>
        <ArtisanGrid
          ref="schedule"
          metaKey="JcScheduleInfo"
          :metaInited="metaInited"
          :query="{ resourceId: resId, scheduleDate: scheduleDate }"
          @row-click="rowClick"
        >
          <template #toolHeader>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 10px;
              "
            >
              <b> {{ deptName }} {{ scheduleDate }} {{ schedulePeriod }} </b>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-date"
                @click="showCalendar = true"
              >
                日历
              </el-button>
            </div>
          </template>
          <template #status="{ row }">
            <el-tag
              :type="statusMap[row.status].type"
              effect="dark"
              size="medium"
            >
              {{ statusMap[row.status].label }}
            </el-tag>
          </template>
        </ArtisanGrid>
      </div>
      <div style="flex: 1; overflow: hidden">
        <ArtisanGrid
          size="mini"
          ref="record"
          :query="{ reserveDate: scheduleDate, resourceId: resId }"
          metaKey="JcApplyBill"
          @row-dblclick="showBillDetail"
        >
          <template #patientName="{ row }">
            <el-button type="text" @click="showBillDetail(row)">{{
              row.patientName
            }}</el-button>
          </template>
          <template #status="{ row, label }">
            <el-tag :type="statusType[row.status]" effect="dark" size="small">
              {{ label }}
            </el-tag>
          </template>
          <template #period="{ row }">
            {{ row.startPoint }}-{{ row.endPoint }}
          </template>
        </ArtisanGrid>
      </div>
    </div>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      height="80%"
      width="80%"
    >
      <RecordDetail
        v-if="dialog.show"
        :query="{ recordId: dialog.billId }"
      ></RecordDetail>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getAuthResource } from "@/api/jc/reserve";
import { loadSchedule } from "@/api/jc/schedule";
import Constant from "@/config/constant.js";
import { buildTree, getClinicTypeLabel, getCalendarInfo } from "@/util/util";
import RecordDetail from "../RecordDetail.vue";
import moment from "moment";
export default {
  components: { RecordDetail },
  inject: ["index"],
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
      },
      showCalendar: false,
      loading: false,
      resources: [],
      resId: "",
      deptName: "",
      depts: [],
      scheduleDate: moment().format("YYYY-MM-DD"),
      schedules: [],
      scheduleId: "",
      schedulePeriod: "",
      dialog: {
        title: "",
        show: false,
        billId: "",
      },
      statusType: {
        wait: "info",
        ok: "primary",
        cancel: "warning",
        scrap: "danger",
        stop: "danger",
        sign: "success",
        check: "success",
        report: "success",
        undo: "danger",
      },
      statusMap: {
        normal: {
          label: "未约满",
          type: "success",
        },
        full: {
          label: "已约满",
          type: "warning",
        },
        stop: {
          label: "已停诊",
          type: "danger",
        },
      },
    };
  },
  computed: {
    dayScheduleMap() {
      let scheduleMap = {};
      this.schedules.forEach((c) => {
        scheduleMap[c.scheduleDate] = c;
      });
      return scheduleMap;
    },
    resTree() {
      let treeData = buildTree(this.resources);
      let roots = [];
      console.log(this.depts, treeData);
      this.depts.forEach((c) => {
        let root = Object.assign({ children: [] }, c);
        root.children = treeData.filter((c) => c.deptId == root.id);
        roots.push(root);
      });
      return roots;
    },
    res() {
      let res = this.resources.find((c) => c.id == this.resId);
      return res || {};
    },
  },
  watch: {
    scheduleDate() {
      this.showCalendar = false;
      this.scheduleId = "";
      this.schedulePeriod = "";
      this.$refs.record.reload({
        reserveDate: this.scheduleDate,
        scheduleId: "",
      });
    },
    resTree() {
      console.log(this.resTree);
    },
  },
  created() {
    getAuthResource().then((res) => {
      this.resources = res.data.data;
      let dm = new Map();
      this.resources.forEach((c) => {
        if (!dm.has(c.deptId)) {
          dm.set(c.deptId, {
            id: c.deptId,
            name: c.deptName,
            type: "dept",
          });
        }
      });
      this.depts = dm.values();
      if (this.resources.length) {
        this.resId = this.resources[0].id;
        this.deptName = this.resources[0].deptName;
        let { start, end } = getCalendarInfo(this.scheduleDate);
        this.loadSchedule(start, end);
      }
    });
  },
  methods: {
    getClinicTypeLabel,
    metaInited(option) {
      option.isPage = false;
      option.rowType = "index";
      option.btns = [];
      option.columns.forEach((c) => {
        c.isSearch = false;
        if (c.code == "weekNo") {
          c.dicData = Constant.weeks.map((c) => {
            return {
              value: c.weekNo,
              label: c.name,
            };
          });
        } else if (c.code == "clinicType") {
          c.dicData = [
            {
              value: "",
              label: "不限",
            },
            {
              value: "outpatient",
              label: "门诊",
            },
            {
              value: "inpatient",
              label: "住院",
            },
          ];
        } else if (c.code == "scheduleDate") {
          c.searchType = "";
        } else if (c.code == "appIds") {
          c.isValid = false;
        } else if (c.code == "clinicType") {
          c.width = "";
        }
      });
      return option;
    },
    handleNodeClick(data) {
      if (!data.type) {
        this.resId = data.id;
        this.deptName = data.deptName;
        let { start, end } = getCalendarInfo(this.scheduleDate);
        this.loadSchedule(start, end);
        this.$refs.schedule.reload({ resourceId: this.resId });
      }
    },
    loadSchedule(start, end) {
      this.loading = true;
      loadSchedule(this.resId, start, end)
        .then((res) => {
          let data = res.data.data;
          this.schedules = data;
          this.$refs.record.reload({});
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    rowClick(row) {
      this.scheduleId = row.id;
      this.schedulePeriod = row.startPoint + "-" + row.endPoint;
      this.scheduleRow = row;
      this.$refs.record.reload({
        reserveDate: "",
        scheduleId: this.scheduleId,
      });
    },
    monthChange({ start, end }) {
      this.loadSchedule(start, end);
    },
    getDateClass(date) {
      let now = moment().format("YYYY-MM-DD");
      if (this.dayScheduleMap[date] && this.dayScheduleMap[date].hasSchedule) {
        return date >= now ? "back-success-light" : "back-info-light";
      }
      return "";
    },
    showBillDetail(row) {
      this.dialog.title = `预约申请单详情--${row.patientName}(${row.id})`;
      this.dialog.billId = row.id;
      this.dialog.show = true;
    },
  },
};
</script>

<style scoped>
.schedule-date {
  height: 40px;
  line-height: 40px;
  width: 40px;
  font-size: 1.5rem;
  margin: 5px;
  text-align: center;
}
.date-current {
  border-radius: 50%;
  background-color: #409eff;
  color: white;
  text-align: center;
}
</style>
